import { get, post, put, del } from '../lib/apiClient';

/** GET /forum/categories */
export const listCategories = () => get('/forum/categories');

/** GET /forum/categories/{categoryId}/threads */
export const listThreads = (categoryId, query) =>
  get(`/forum/categories/${encodeURIComponent(categoryId)}/threads`, { query });

/** POST /forum/categories/{categoryId}/threads — { title, content } */
export const createThread = (categoryId, payload) =>
  post(`/forum/categories/${encodeURIComponent(categoryId)}/threads`, payload);

/** GET /forum/threads/{threadId} — thread with paginated posts (limit/lastEvaluatedKey) */
export const getThread = (threadId, query) =>
  get(`/forum/threads/${encodeURIComponent(threadId)}`, { query });

/** POST /forum/threads/{threadId}/posts — { content } reply */
export const createPost = (threadId, payload) =>
  post(`/forum/threads/${encodeURIComponent(threadId)}/posts`, payload);

/** PUT /forum/posts/{postId} — edit own post */
export const updatePost = (postId, payload) =>
  put(`/forum/posts/${encodeURIComponent(postId)}`, payload);

/** DELETE /forum/posts/{postId} — author, or moderator deleting any post */
export const deletePost = (postId) => del(`/forum/posts/${encodeURIComponent(postId)}`);

/** GET /forum/search?q=&limit=&lastEvaluatedKey= */
export const search = (query) => get('/forum/search', { query });

// ---- Moderation (FEA-19) — staff (isModerator server-side: staff role or
// forum:moderate:all permission). All four return { thread } with the
// updated fields already applied. ----

/** POST /forum/threads/{threadId}/lock */
export const lockThread = (threadId) => post(`/forum/threads/${encodeURIComponent(threadId)}/lock`);

/** POST /forum/threads/{threadId}/unlock */
export const unlockThread = (threadId) => post(`/forum/threads/${encodeURIComponent(threadId)}/unlock`);

/** POST /forum/threads/{threadId}/pin */
export const pinThread = (threadId) => post(`/forum/threads/${encodeURIComponent(threadId)}/pin`);

/** POST /forum/threads/{threadId}/unpin */
export const unpinThread = (threadId) => post(`/forum/threads/${encodeURIComponent(threadId)}/unpin`);

/** DELETE /forum/threads/{threadId} — moderator only; soft delete */
export const deleteThread = (threadId) => del(`/forum/threads/${encodeURIComponent(threadId)}`);

// ---- Category admin (FEA-19) — isForumAdmin server-side: admin role or
// forum:manage:all permission. The UI gates these on role === 'admin'. ----

/** POST /forum/categories — { name, description, accreditedOnly, accessCriteria, externallySearchable, sortOrder } */
export const createCategory = (payload) => post('/forum/categories', payload);

/** PUT /forum/categories/{categoryId} — same fields + isActive; partial update */
export const updateCategory = (categoryId, payload) =>
  put(`/forum/categories/${encodeURIComponent(categoryId)}`, payload);

/**
 * PUT /forum/categories/{categoryId}/searchability — moderator (not just
 * admin): the one category-level toggle non-admin staff may flip directly.
 */
export const setCategorySearchability = (categoryId, externallySearchable) =>
  put(`/forum/categories/${encodeURIComponent(categoryId)}/searchability`, { externallySearchable });
